import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogActions, Button, Grid } from '@material-ui/core';
import AppBarModal from './../../general/AppBarModal';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
  },
}));

const ModalVerificacionDatos = ({ open, onClose, onAceptar, actualizacionSw }) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby='customized-dialog-title'
      open={open}
      fullWidth={true}
      maxWidth='sm'
      className='scroll'
    >
      <AppBarModal
        titulo="Verificación de Datos Personales"
        mostrarModal={onClose}
      />
      <DialogContent style={{ padding: '30px 24px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '20px',
              borderRadius: '8px',
              border: '2px solid #dee2e6',
              marginBottom: '6px'
            }}>
              <p style={{
                fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                margin: '0',
                color: '#495057',
                fontWeight: '500'
              }}>
                Por favor, <strong style={{ color: '#dc3545' }}>verifique los datos personales</strong> en su solicitud. Si algún dato es incorrecto o requiere actualización, realice la corrección en el formulario. Si los datos son correctos, haga clic en "Aceptar verificación de datos".
              </p>
            </div>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{
        padding: '20px 24px',
        backgroundColor: '#f8f9fa',
        borderTop: '2px solid #dee2e6',
        justifyContent: 'space-between'
      }}>
       

        {actualizacionSw && <Button
          onClick={onAceptar}
          className={classes.button}
          variant="outlined"
          style={{
            color: '#6c757d',
            borderColor: '#6c757d',
            minWidth: '130px',
            fontWeight: '600'
          }}

        >
          Actualización de Datos
        </Button>
        }
        <Button
          color='primary'
          onClick={onClose}
          variant="contained"
          className={classes.button}
          style={{
            minWidth: '180px',
            fontWeight: '600',
            fontSize: '14px'
          }}
        >
          Aceptar verificación de datos
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalVerificacionDatos;